const EditTemplate = () => {
	return <div>Edit Template</div>;
};

export default EditTemplate;
